/*
 * revmore.js -- rozbaleni dlouhe karty Google recenze na strance Reference
 * (17-02, Owner Decision Faze 17 #12, 7. 9. 2026).
 *
 * PROGRESIVNI VYLEPSENI. `revgrid.php` vzdy vypise CELY text citace do DOM;
 * bez JS zustava tlacitko `.revmore` schovane atributem `hidden` a text je
 * plne viditelny -- prah delky a orez `.is-clamp` jsou az vec CSS/JS, ne
 * chybejici data. Tenhle modul jen ODKRYVA tlacitko a rika CSS, kdy ma
 * orezavat.
 *
 * ZADNY REFLOW MERENI. Prah delky uz vyresil PHP (420 znaku, zmereno na
 * datech) -- modul tu jen preklopi stav `hidden -> viditelne` a
 * `.is-clamp -> .is-open`, nepocita vysky ani radky.
 */

/**
 * Spusti rozbalovani dlouhych karet Google recenzi na Reference.
 *
 * @returns {void}
 */
export function init() {
	const tlacitka = [].slice.call(document.querySelectorAll('.rev2 .revmore'));

	tlacitka.forEach(function (tlacitko) {
		const id = tlacitko.getAttribute('aria-controls');
		const odstavec = id ? document.getElementById(id) : null;

		if (!odstavec) {
			return;
		}

		tlacitko.hidden = false;

		tlacitko.addEventListener('click', function () {
			odstavec.classList.add('is-open');
			tlacitko.setAttribute('aria-expanded', 'true');
			tlacitko.hidden = true;
		});
	});
}
